// extracted by mini-css-extract-plugin
export default {"profilePhoto":"GrayProfilePhotoCircle_profilePhoto__vFiov"};